// Données structurées pour les 3 branches de services PaysFor

export const serviceCategories = {
  abattageElagage: {
    id: 'abattage-elagage',
    title: 'Abattage & Élagage',
    slug: '/abattage-elagage',
    description: 'Services professionnels d\'arboriculture pour l\'entretien et l\'abattage sécuritaire de vos arbres à Québec et dans la Capitale-Nationale.',
    heroImage: 'https://customer-assets.emergentagent.com/job_arborist-services/artifacts/v7r7q29n_81f75804-7938-43ab-ad75-e270ffb00067.jpg',
    seo: {
      title: 'Abattage d\'arbres et élagage à Québec | PaysFor',
      description: 'Services professionnels d\'abattage d\'arbres, élagage, démontage et essouchage à Québec. Équipe certifiée dans la Capitale-Nationale. Soumission gratuite.',
      keywords: 'abattage arbres Québec, élagage Québec, démontage arbres, taille haies Québec, essouchage Capitale-Nationale'
    },
    services: [
      {
        id: 'abattage-arbres',
        title: 'Abattage d\'arbres',
        slug: '/abattage-arbre-quebec',
        description: 'Service professionnel d\'abattage sécuritaire pour tous types d\'arbres, dangereux ou non. Équipement spécialisé et techniques éprouvées pour un travail propre et efficace.',
        benefits: ['Sécurité maximale', 'Nettoyage complet du site', 'Respect des propriétés avoisinantes', 'Équipement adapté à chaque situation'],
        image: 'https://customer-assets.emergentagent.com/job_arborist-services/artifacts/v7r7q29n_81f75804-7938-43ab-ad75-e270ffb00067.jpg'
      },
      {
        id: 'elagage',
        title: 'Élagage',
        slug: '/elagage-quebec',
        description: 'Taille précise pour la santé et l\'esthétique de vos arbres. Techniques respectueuses favorisant une croissance optimale et la longévité de vos végétaux.',
        benefits: ['Amélioration de la santé de l\'arbre', 'Esthétique soignée', 'Prévention des risques', 'Techniques professionnelles'],
        image: 'https://customer-assets.emergentagent.com/job_972aa941-b618-44c7-b555-7700fb81204b/artifacts/rt7jsnob_42f10c2d-52b7-4833-a9a9-e144883cb78d.jpg'
      },
      {
        id: 'demontage-arbres',
        title: 'Démontage d\'arbres',
        slug: '/demontage-arbres-quebec',
        description: 'Démontage pièce par pièce d\'arbres en milieu restreint ou près de structures. Technique sécuritaire pour les situations délicates.',
        benefits: ['Technique adaptée aux espaces restreints', 'Protection des structures', 'Travail méthodique', 'Gestion sécuritaire des branches'],
        image: 'https://customer-assets.emergentagent.com/job_972aa941-b618-44c7-b555-7700fb81204b/artifacts/a2pv2tmz_194eff2e-324b-48ac-9491-0bae511366a3.jpg'
      },
      {
        id: 'taille-haies',
        title: 'Taille / Rabaissement de haie',
        slug: '/taille-haies-quebec',
        description: 'Entretien régulier et taille professionnelle de vos haies pour un aspect impeccable. Rabaissement de haies trop hautes.',
        benefits: ['Forme harmonieuse', 'Densité contrôlée', 'Croissance uniforme', 'Entretien saisonnier'],
        image: 'https://customer-assets.emergentagent.com/job_arborist-services/artifacts/dvo8jlcx_IMG_20250731_141410%281%29.jpg'
      },
      {
        id: 'essouchage',
        title: 'Essouchage',
        slug: '/essouchage-quebec',
        description: 'Extraction complète de souches d\'arbres avec machinerie spécialisée. Service rapide et efficace pour libérer votre terrain.',
        benefits: ['Machinerie adaptée', 'Extraction complète', 'Terrain prêt pour aménagement', 'Service rapide'],
        image: 'https://customer-assets.emergentagent.com/job_arborist-services/artifacts/nrd092ig_57daffdd-665c-4514-971a-9b5d2f076a36.jpg'
      }
    ]
  },
  paysagement: {
    id: 'paysagement',
    title: 'Paysagement',
    slug: '/paysagement',
    description: 'Services complets d\'aménagement paysager pour transformer et embellir votre propriété à Québec et dans la Capitale-Nationale.',
    heroImage: 'https://customer-assets.emergentagent.com/job_arborist-services/artifacts/g9it91th_20250724_164248.jpg',
    seo: {
      title: 'Aménagement paysager à Québec | Paysagement | PaysFor',
      description: 'Services de paysagement professionnel à Québec : plantation d\'arbres, haies de cèdres, plates-bandes, paillis et nivellement. Soumission gratuite.',
      keywords: 'paysagement Québec, aménagement paysager Capitale-Nationale, plantation arbres, plantation cèdres, plates-bandes Québec'
    },
    services: [
      {
        id: 'amenagement-paysager',
        title: 'Aménagement paysager',
        slug: '/amenagement-paysager-quebec',
        description: 'Conception et réalisation d\'aménagements paysagers complets. Du design à l\'exécution, nous transformons votre espace extérieur.',
        benefits: ['Conception personnalisée', 'Végétaux adaptés au climat québécois', 'Mise en valeur de votre propriété', 'Service clé en main'],
        image: 'https://customer-assets.emergentagent.com/job_arborist-services/artifacts/g9it91th_20250724_164248.jpg'
      },
      {
        id: 'plantation-arbres',
        title: 'Plantation d\'arbres',
        slug: '/plantation-arbres-quebec',
        description: 'Plantation professionnelle d\'arbres pour embellir votre terrain. Sélection des essences adaptées et techniques de plantation optimales.',
        benefits: ['Sélection des bonnes essences', 'Technique appropriée', 'Conseils d\'entretien', 'Garantie de reprise'],
        image: 'https://customer-assets.emergentagent.com/job_arborist-services/artifacts/g9it91th_20250724_164248.jpg'
      },
      {
        id: 'plantation-cedres',
        title: 'Plantation de cèdres et haies',
        slug: '/plantation-cedres-quebec',
        description: 'Installation de haies de cèdres pour intimité et protection. Choix des variétés adaptées et plantation soignée.',
        benefits: ['Intimité garantie', 'Écran naturel', 'Croissance rapide', 'Entretien facile'],
        image: 'https://customer-assets.emergentagent.com/job_arborist-services/artifacts/2l1t9hxm_Screenshot_20250212_210136_Gallery.jpg'
      },
      {
        id: 'plates-bandes',
        title: 'Plates-bandes',
        slug: '/plates-bandes-quebec',
        description: 'Création et entretien de plates-bandes fleuries ou arbustives. Design harmonieux adapté à votre propriété.',
        benefits: ['Design personnalisé', 'Choix de plantes adaptées', 'Entretien saisonnier', 'Beauté durable'],
        image: 'https://customer-assets.emergentagent.com/job_arborist-services/artifacts/g9it91th_20250724_164248.jpg'
      },
      {
        id: 'paillis-bordures',
        title: 'Paillis et bordures',
        slug: '/paillis-bordures-quebec',
        description: 'Installation de paillis décoratif et bordures pour un aspect soigné. Protection des plantations et réduction de l\'entretien.',
        benefits: ['Aspect soigné', 'Réduction des mauvaises herbes', 'Protection des racines', 'Plusieurs choix de matériaux'],
        image: 'https://customer-assets.emergentagent.com/job_arborist-services/artifacts/g9it91th_20250724_164248.jpg'
      },
      {
        id: 'nivellement',
        title: 'Nivellement et préparation de terrain',
        slug: '/nivellement-terrain-quebec',
        description: 'Préparation et nivellement de terrain pour vos projets d\'aménagement. Base solide pour des résultats durables.',
        benefits: ['Terrain bien préparé', 'Drainage optimal', 'Base solide', 'Prêt pour plantation'],
        image: 'https://customer-assets.emergentagent.com/job_arborist-services/artifacts/g9it91th_20250724_164248.jpg'
      }
    ]
  },
  travauxForestiers: {
    id: 'travaux-forestiers',
    title: 'Travaux forestiers',
    slug: '/travaux-forestiers',
    description: 'Services spécialisés en milieu forestier pour le déboisement, débroussaillage et travaux en boisé dans la région de Québec.',
    heroImage: 'https://customer-assets.emergentagent.com/job_972aa941-b618-44c7-b555-7700fb81204b/artifacts/m1t2zcr9_53c55735-3ddf-465f-9df7-59a1e6963531.jpg',
    seo: {
      title: 'Travaux forestiers à Québec | Déboisement | PaysFor',
      description: 'Services de travaux forestiers professionnels à Québec : déboisement, débroussaillage, chemins forestiers et travaux en boisé. Soumission gratuite.',
      keywords: 'travaux forestiers Québec, déboisement Capitale-Nationale, débroussaillage, chemins forestiers, travaux boisé Québec'
    },
    services: [
      {
        id: 'deboisement',
        title: 'Déboisement',
        slug: '/deboisement-quebec',
        description: 'Déboisement contrôlé pour projets forestiers, agricoles ou de développement. Respect des normes environnementales.',
        benefits: ['Planification rigoureuse', 'Machinerie adaptée', 'Conformité réglementaire', 'Respect de l\'environnement'],
        image: 'https://customer-assets.emergentagent.com/job_972aa941-b618-44c7-b555-7700fb81204b/artifacts/m1t2zcr9_53c55735-3ddf-465f-9df7-59a1e6963531.jpg'
      },
      {
        id: 'debroussaillage',
        title: 'Débroussaillage',
        slug: '/debroussaillage-quebec',
        description: 'Service spécialisé de débroussaillage en milieu forestier pour entretien de sentiers, lignes électriques et zones de coupe.',
        benefits: ['Équipement forestier professionnel', 'Respect du milieu naturel', 'Intervention en terrain difficile', 'Nettoyage complet'],
        image: 'https://customer-assets.emergentagent.com/job_972aa941-b618-44c7-b555-7700fb81204b/artifacts/m1t2zcr9_53c55735-3ddf-465f-9df7-59a1e6963531.jpg'
      },
      {
        id: 'degagement-plantations',
        title: 'Dégagement de plantations',
        slug: '/degagement-plantations-quebec',
        description: 'Élagage spécialisé pour plantations forestières et reboisement. Favorise une croissance optimale des arbres.',
        benefits: ['Technique forestière', 'Amélioration de la qualité du bois', 'Croissance dirigée', 'Intervention professionnelle'],
        image: 'https://customer-assets.emergentagent.com/job_972aa941-b618-44c7-b555-7700fb81204b/artifacts/m1t2zcr9_53c55735-3ddf-465f-9df7-59a1e6963531.jpg'
      },
      {
        id: 'preparation-terrain',
        title: 'Préparation de terrain',
        slug: '/preparation-terrain-forestier-quebec',
        description: 'Préparation de terrains forestiers pour reboisement ou projets de développement.',
        benefits: ['Terrain bien préparé', 'Accès facilité', 'Prêt pour plantation', 'Service complet'],
        image: 'https://customer-assets.emergentagent.com/job_972aa941-b618-44c7-b555-7700fb81204b/artifacts/m1t2zcr9_53c55735-3ddf-465f-9df7-59a1e6963531.jpg'
      },
      {
        id: 'travaux-boise',
        title: 'Travaux en boisé',
        slug: '/travaux-boise-quebec',
        description: 'Interventions diverses en milieu boisé : entretien, nettoyage, amélioration de lots boisés.',
        benefits: ['Expertise en milieu forestier', 'Équipement adapté', 'Respect de l\'écosystème', 'Valorisation du boisé'],
        image: 'https://customer-assets.emergentagent.com/job_972aa941-b618-44c7-b555-7700fb81204b/artifacts/m1t2zcr9_53c55735-3ddf-465f-9df7-59a1e6963531.jpg'
      },
      {
        id: 'chemins-forestiers',
        title: 'Chemins forestiers',
        slug: '/chemins-forestiers-quebec',
        description: 'Création et entretien de chemins forestiers pour accès aux lots boisés et travaux forestiers.',
        benefits: ['Accès facilité', 'Drainage adéquat', 'Durabilité', 'Respect du terrain'],
        image: 'https://customer-assets.emergentagent.com/job_972aa941-b618-44c7-b555-7700fb81204b/artifacts/m1t2zcr9_53c55735-3ddf-465f-9df7-59a1e6963531.jpg'
      }
    ]
  }
};

// Navigation structure for the header
export const navigationMenu = [
  { path: '/', label: 'Accueil', hasDropdown: false },
  {
    path: '/abattage-elagage',
    label: 'Abattage & Élagage',
    hasDropdown: true,
    dropdownItems: serviceCategories.abattageElagage.services.map(s => ({
      path: s.slug,
      label: s.title
    }))
  },
  {
    path: '/paysagement',
    label: 'Paysagement',
    hasDropdown: true,
    dropdownItems: serviceCategories.paysagement.services.map(s => ({
      path: s.slug,
      label: s.title
    }))
  },
  {
    path: '/travaux-forestiers',
    label: 'Travaux forestiers',
    hasDropdown: true,
    dropdownItems: serviceCategories.travauxForestiers.services.map(s => ({
      path: s.slug,
      label: s.title
    }))
  },
  { path: '/realisations', label: 'Réalisations', hasDropdown: false },
  { path: '/a-propos', label: 'À propos', hasDropdown: false }
];

// URL redirects for old pages (301 redirects)
export const urlRedirects = {
  '/services': '/abattage-elagage',
  '/services#residential': '/abattage-elagage',
  '/services#commercial': '/abattage-elagage',
  '/services#forestry': '/travaux-forestiers'
};
